import { type Common } from './common.js';
import type * as Places from './models/places.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findTextSearchSuggestions(args: {
    input: string;
    kind?: Places.Kind;
    latitude?: number | null;
    longitude?: number | null;
  }): Promise<Places.PlaceSuggestion[]> {
    const url = this.common.constructPath('/patient-previsit/places/text-search', args);

    return await this.common.getJSON(url);
  }

  async findAutocompleteSuggestions(args: {
    input: string;
    practiceId?: string;
    latitude?: number;
    longitude?: number;
  }): Promise<Places.PlaceSuggestion[]> {
    const url = this.common.constructPath('/patient-previsit/places/autocomplete', args);

    return await this.common.getJSON(url);
  }

  async findPlaceDetails(placeId: string): Promise<Places.PlaceDetails> {
    const url = this.common.constructPath('/patient-previsit/places/details', {
      placeId,
    });

    return await this.common.getJSON(url);
  }
}
